var _rect, _rect2, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.64532,
    y: 0.755127,
    width: 14.5,
    height: 14.5,
    rx: 3.25,
    fill: "#ED3241"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.64532,
    y: 0.755127,
    width: 14.5,
    height: 14.5,
    rx: 3.25,
    stroke: "#ED3241",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_392_7502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 11,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6903 4.92265C13.9667 5.20452 13.9627 5.65743 13.6812 5.93426L7.7264 11.7916L4.10916 8.23357C3.82772 7.95674 3.82365 7.50383 4.10006 7.22197C4.37647 6.9401 4.82869 6.93602 5.11013 7.21285L7.7264 9.78631L12.6803 4.91354C12.9617 4.63671 13.4139 4.64079 13.6903 4.92265Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_392_7502)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.89557,
    y: 3.00519,
    width: 9.99961,
    height: 9.99961,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.4ce5051327003494bb11c3df7ec05b3c.svg";
export { ForwardRef as ReactComponent };